import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../auth/auth.service';
import { Subscription } from 'rxjs';
import { LoggedInUser } from '../../models/loggedInUser.model';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../api.service';
import { decodeBase64ToText } from '../../utility';
import { ToastService } from '../services/toast.service';
import { HelperService } from '../services/helper.service';
import { HttpService } from '../services/http.service';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit, OnDestroy {
  env = environment;
  isEditProfile: boolean = false;
  // header menu
  menuItems: MenuItem[] | undefined;
  userInfo: any;
  // Highlight the list menu
  isToDoRoute: boolean = false;
  isWorkPackageRoute: boolean = false;

  // User authentication
  isAuthenticated = false;
  loggedInUser: LoggedInUser;
  isNewNotification: boolean = true;

  // Header Avatar menu
  selectedCategory: any = null;
  currentQuater: any = null;

  private userSub: Subscription;
  private checkAuth: Subscription;
  private apiService = inject(ApiService);
  private readonly auth = inject(AuthService);
  private httpService = inject(HttpService);

  helper = inject(HelperService);
  uplodedProfilePic: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private cookieService: CookieService
  ) {}


  designations: any[] = [
    { name: 'Affiliate', key: 'AFF' },
    { name: 'Admin', key: 'ADM' },
    { name: 'Oncology Lead', key: 'ONCO LEAD' },
  ];

  categories: any[] = [
    { name: 'Admin', key: 'admin' },
    { name: 'Affiliate', key: 'affiliate' },
    { name: 'IEL', key: 'iel' },
    { name: 'Lead', key: 'lead' },
    { name: 'Default', key: 'member' },
  ];

  ngOnInit() {
    this.auth.getLoggedInUser();

    this.userSub = this.authService.user.subscribe((user) => {
      this.loggedInUser = user;
      this.profilePic = user.userData.avatar;
      this.uplodedProfilePic=user.userData.avatar
    });
    this.checkAuth = this.authService.isAuthenticated.subscribe(
      (didAuthenticated) => {
        this.isAuthenticated = didAuthenticated;
      }
    );

    this.selectedCategory = this.categories[4];
    this.apiService.role$.subscribe((data) => {
      const index = this.categories.findIndex((item) => item.key === data);
      this.selectedCategory = this.categories[index];
    });

    this.fetchCurrentQuater();

    this.menuItems = [
      {
        label: 'Home',
        route: '/home',
      },
      {
        label: 'Outcomes',
        route: '/outcomes',
      },
      {
        label: 'Work Packages',
        highlight: this.isWorkPackageRoute,
        items: [
          {
            label: 'Dashboard',
            route: '/wp/dashboard',
          },
          {
            label: 'Work Packages List',
            route: '/wp/list',
          },
        ],
      },
      {
        label: 'To - Do',
        highlight: this.isToDoRoute,
        items: [
          {
            label: 'My Tasks',
            route: '/myTasks',
          },
          {
            label: 'Dependencies',
            route: '/dependencies',
          },
        ],
      },
    ];
    if (this.route.snapshot.url.length > 0) {
      var currentRoute = this.route.snapshot.url[0].path;
    } else {
      var currentRoute = '';
    }

    if (currentRoute == 'dependencies' || currentRoute == 'myTasks') {
      this.isToDoRoute = true;
    } else if (currentRoute == 'wp') {
      this.isWorkPackageRoute = true;
    } else {
      this.isToDoRoute = false;
      this.isWorkPackageRoute = false;
    }

    this.userInfo = JSON.parse(decodeBase64ToText(this.auth.getCookie()));
  }

  openDialog() {
    // this.uplodedProfilePic=this.profilePic || ''
    this.isEditProfile = true;
  }

  closeDialog(fileInput: HTMLInputElement) {
    this.uplodedProfilePic=this.profilePic || ''
    this.isEditProfile = false;
    fileInput.value = '';

    
  }
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>; // Reference to the file input element

  profilePic: any;
  selectedFile: File | null = null;
  triggerFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    } else {
      console.error('fileInput is null when trying to trigger click');
    }
  }
  ngAfterViewInit(): void {
    if (!this.fileInput) {
      console.error('File input reference is null!');
    }
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        
        this.uplodedProfilePic = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
  saveChanges() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);

      // Make HTTP request to upload the file
      this.httpService
        .postForm(
          `${environment.opbBackendHost}/api/member/profile/image/update`,
          formData
        )
        .subscribe({
          next: (res: any) => {
            let response = res;
            this.profilePic = response?.data.avatar || '';
            this.auth.getLoggedInUser();
            response?.error
              ? this.toastService.error(response?.message)
              : this.toastService.success(response?.message);
              this.isEditProfile = false;
            },
          error: (error) => {
            console.error('Error uploading profile picture:', error);
          },
        });
    } else {
      console.warn('No file selected!');
    }
  }

  selectDesignation(value: any) {
    if (value.name == 'Admin') {
      this.router.navigate(['/admin/timelines']);
    } else {
      // this.router.navigate(['/home']);
      this.apiService.setRole(value['key']);
      window.location.reload();
    }
  }

  get getUserName() {
    return this.userInfo?.data?.name; // "Sumit Chauhan"
  }

  fetchCurrentQuater() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/quarter`, {})
      .subscribe((res: any) => {
        this.currentQuater = res?.data?.quarter;
        this.apiService.setQuarter(this.currentQuater);
      });
  }

  logOut() {
    this.httpService
      .get(`${environment.opbBackendHost}/api/auth/logout`)
      .subscribe((response: any) => {
        if (response) {
          this.toastService.success(response?.message);
          this.authService.logOut();
          this.router.navigate(['/']);
        }
      });
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
    this.checkAuth.unsubscribe();
  }
}
